import React from 'react'
import { agnostify, getBrowsePath, getSearchPath } from '@sainsburys-tech/boltui-utils'
import CountUp from '../CountUp/CountUp'
import * as Styled from '../../product-finder.styles'
import { onLinkClickFn } from '../../../../../helpers/ComponentHelper'

const getBrowseUrl = (categoryId, activeFilters, currentCount, productId, searchTerm) => {
  if (productId) {
    return `/product/${productId}`
  }

  if (searchTerm) {
    return getSearchPath(searchTerm, {
      isCannedSearch: true,
      categoryId: activeFilters?.category,
      filterUriFragments: currentCount > 0 && activeFilters
    })
  }

  return getBrowsePath({
    categoryId,
    filterUriFragments: currentCount > 0 && activeFilters
  }).replace('/browse//', '/browse/') // quick fix for getBrowsePath in this instance, Andy Girvan will absolutely come back and fix the actual bug he pinky promises
}

const Results = ({
  categoryId,
  activeFilters,
  currentCount,
  previousCount,
  productId,
  resultsMargin,
  baseCategory,
  onLinkClick,
  resultsText,
  resultsButtonKind,
  searchTerm,
  trackInteraction
}) => {
  const linkUrl = `${getBrowseUrl(
    categoryId,
    activeFilters,
    currentCount,
    productId,
    searchTerm
  )}?clickOrigin=productFinder`

  return (
    <Styled.ResultsButton
      kind={resultsButtonKind}
      onClick={(event) => {
        onLinkClickFn(event, onLinkClick, linkUrl)
        trackInteraction('results')
      }}
      title='View results'
      href={agnostify(linkUrl)}
      forwardedAs='a'
      resultsMargin={resultsMargin}
      currentCount={currentCount}
    >
      {currentCount === 0 && <>Sorry, there&apos;s no matches for your search. Browse all instead</>}
      {currentCount === 1 && (
        <>
          View <CountUp start={previousCount} end={currentCount} duration={1.5} /> {baseCategory || 'product'} available
        </>
      )}
      {currentCount > 1 && (
        <>
          View <CountUp start={previousCount} end={currentCount} duration={1.5} /> products {resultsText}
        </>
      )}
    </Styled.ResultsButton>
  )
}

export default Results
